export const AUDIO_ABBREVIATIONS_REPORT_SUCCESS = 'SUCCESS';
export const AUDIO_ABBREVIATIONS_REPORT_ERROR = 'ERROR';
export const AUDIO_ABBREVIATIONS_REPORT_LOADING = 'LOADING';
